import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { authClient } from "@core/clients";
import { VerificationCodeResponse } from "@core/types";

const useGetSmsCode = (options?: UseMutationOptions<VerificationCodeResponse, any, { phone: string }>) =>
  useMutation(
    ["get-sms-code"],
    async ({ phone }): Promise<VerificationCodeResponse> => {
      const data = await authClient.getSmsCode(phone);

      return data;
    },
    options
  );

export default useGetSmsCode;
